import { useEffect, useRef } from 'react';

export default function ParticleCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let W, H, pts = [];
    const resize = () => { W = canvas.width = window.innerWidth; H = canvas.height = window.innerHeight; };
    resize();
    window.addEventListener('resize', resize);
    const pcols = ['rgba(107,95,160,','rgba(27,31,94,','rgba(211,47,47,'];
    for(let i=0;i<60;i++) pts.push({
      x:Math.random()*3000,y:Math.random()*2000,
      r:Math.random()*1.2+.3,
      vx:(Math.random()-.5)*.15,vy:(Math.random()-.5)*.15,
      c:pcols[~~(Math.random()*3)],o:Math.random()*.15+.04
    });
    let raf;
    const draw = () => {
      ctx.clearRect(0,0,W,H);
      pts.forEach(p => {
        p.x+=p.vx; p.y+=p.vy;
        if(p.x<0)p.x=W; if(p.x>W)p.x=0;
        if(p.y<0)p.y=H; if(p.y>H)p.y=0;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle=p.c+p.o+')'; ctx.fill();
      });
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => { window.removeEventListener('resize',resize); cancelAnimationFrame(raf); };
  }, []);

  return <canvas ref={canvasRef} id="bgc" />;
}
